<template>
  <components v-if="tax_no" :is="checkUseWhick()"></components>
</template>
<script>
const SysNcTemplateManagerDefault = () => import('./SysNcTemplateManagerComp/SysNcTemplateManagerDefault.vue')
const SysNcTemplateManagerYE = () => import('./SysNcTemplateManagerComp/SysNcTemplateManagerYE.vue')
export default {
  components: {
    SysNcTemplateManagerDefault,
    SysNcTemplateManagerYE
  },
  data() {
    return {
      tax_no: ''
    }
  },
  created() {
    this.getAccountModuleType()
  },
  methods: {
    // 通过模块控制映射按钮权限
    getAccountModuleType() {
      let tenantId = typeof sessionStorage.getItem('tenantId') == 'undefined' ? sessionStorage.getItem('tenantId') : sessionStorage.getItem('currentTenantId')
      this.tenantId = tenantId
      if (tenantId) {
        this.$http.get('${third}/system/account_mangement/getByTenantIdAndModule?id=' + `${tenantId}&accountModule=6`).then((res) => {
          if (res && res.data) {
            this.tax_no = res.data.tax_no
          }
        })
      }
    },
    checkUseWhick() {
      switch (this.tax_no) {
        case 'yon_u8':
          return 'SysNcTemplateManagerYE'
        default:
          return 'SysNcTemplateManagerDefault'
      }
    }
  }
}
</script>
